export const CyManageSongbooks = {
  ManageSongbooksTable: "ManageSongbooksTable",
  EditSongbookButton: "EditSongbookButton",
  DeleteSongbookButton: "DeleteSongbookButton",
} as const;
